import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, inject, OnInit, signal, ViewEncapsulation, WritableSignal } from '@angular/core';

import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslocoService } from '@ngneat/transloco';
import { CreatePortReportComponent } from '@vessel-reports/port/components/create-port-report/create-port-report.component';
import { PortReportDetailsComponent } from '@vessel-reports/port/components/port-report-details/port-report-details.component';
import { PortReportType } from '@vessel-reports/port/state/port.types';

@Component({
  selector: 'port-report-dialog',
  templateUrl: './port-report-dialog.component.html',
  styleUrl: './port-report-dialog.component.scss',
  encapsulation: ViewEncapsulation.None,
  imports: [CreatePortReportComponent, PortReportDetailsComponent],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PortReportDialogComponent implements OnInit {
  protected readonly translocoService: TranslocoService = inject(TranslocoService);

  type: WritableSignal<PortReportType> = signal('create-new');

  constructor(
    private _matDialogRef: MatDialogRef<PortReportDialogComponent>,
    private _changeDetector: ChangeDetectorRef,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit() {
    if (this.data?.type === 'details') {
      this.type.set('details');
    }
  }

  onSaveCreate() {
    this.type.set('details');
  }

  onClose() {
    this._matDialogRef.close();
  }
}
